export const ARCHIVED_COLUMNS_SET = 'Campaigns/archived-columns-set';
export const CAMPAIGN_SELECT = 'Campaigns/campaign-select';
export const CAMPAIGN_COLUMNS_SET = 'Campaigns/campaign-columns-set';
export const CAMPAIGN_SET = 'Campaigns/campaign-set';
export const ERROR_MESSAGE_SET = 'Campaigns/error-message-set';
export const SHOW_SET = 'Campaigns/show-set';
export const TAB_SELECT = 'Campaigns/tab-select';
export const VIEW_CAMPAIGN = 'Campaigns/view-campaign';
